module.exports = __webpack_public_path__ + "img/sitemap.cc95f2cf.svg";